import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation25({ animation, badge, all_animations }: Props) {
  const [showBadge, setShowBadge] = useState(false)

  useEffect(() => {
    setTimeout(() => setShowBadge(true), 300)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes wave1 {
          0%, 100% {
            transform: translateY(0) scaleY(1);
          }
          50% {
            transform: translateY(-20px) scaleY(1.2);
          }
        }
        @keyframes wave2 {
          0%, 100% {
            transform: translateY(0) scaleY(1);
          }
          50% {
            transform: translateY(-30px) scaleY(0.9);
          }
        }
        @keyframes wave3 {
          0%, 100% {
            transform: translateY(0) scaleY(1);
          }
          50% {
            transform: translateY(-15px) scaleY(1.1);
          }
        }
        @keyframes floatBadge {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        .wave-1 { animation: wave1 3s ease-in-out infinite; }
        .wave-2 { animation: wave2 2.5s ease-in-out infinite 0.5s; }
        .wave-3 { animation: wave3 2s ease-in-out infinite 1s; }
        .float-badge { animation: floatBadge 2s ease-in-out infinite; }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh] relative overflow-hidden">
        {/* Vagues en arrière-plan */}
        <div className="absolute inset-0 flex items-end justify-center pointer-events-none">
          <div className="wave-3 absolute bottom-0 w-[200%] h-32 bg-tessan-yellow/10 rounded-t-full" style={{ left: '-50%' }} />
          <div className="wave-2 absolute bottom-0 w-[200%] h-40 bg-tessan-yellow/15 rounded-t-full" style={{ left: '-50%' }} />
          <div className="wave-1 absolute bottom-0 w-[200%] h-48 bg-tessan-yellow/20 rounded-t-full" style={{ left: '-50%' }} />
        </div>

        {/* Badge flottant */}
        <div className={`relative z-10 transition-all duration-1000 ${showBadge ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}`}>
          <div className="float-badge">
            <div className="w-32 h-32 sm:w-44 sm:h-44 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/50">
              <span className="text-6xl sm:text-8xl">{badge.emoji}</span>
            </div>
          </div>
        </div>

        <div className={`mt-8 text-center relative z-10 transition-all duration-700 delay-500 ${showBadge ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow">{badge.name}</div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
        </div>
      </div>
    </AnimationLayout>
  )
}
